import { render, staticRenderFns } from "./create-customer.vue?vue&type=template&id=3b98c1c2&"
import script from "./create-customer.vue?vue&type=script&lang=tsx&"
export * from "./create-customer.vue?vue&type=script&lang=tsx&"
import style0 from "./create-customer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports